import React, {Component} from "react";  import config from 'react-global-configuration';
import "react-tabs/style/react-tabs.css";
import jwt_decode from "jwt-decode";
import axios from "axios";
import $ from "jquery";
import Select from 'react-select';
import {css} from "@emotion/core";
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import { List } from 'react-virtualized';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import 'bootstrap-daterangepicker/daterangepicker.css';
import * as moment from "moment";
import ModalD from "react-awesome-modal";
import {connect}  from  "react-redux";
import loadingGif from "../../assets/img/loading.gif";
import {BeatLoader} from "react-spinners";
import {confirmAlert} from 'react-confirm-alert';
import { isApiResponse, isReportAccess, date_range_config, aplloClient, unauthorize_access,user_activities } from '../../helpers/utils.js';
import DownloadAllReport from '../DownloadReport/DownloadAllReport.jsx';
import MerchantFilter from '../../filters/MerchantFilter.jsx';
import ChainFilter from '../../filters/ChainFilter.jsx';
import StoreFilter from '../../filters/StoreFilter.jsx';
import UtidFilter from '../../filters/UtidFilter.jsx';
import ServiceFilter from '../../filters/ServiceFilter.jsx';
import ProductTypeFilter from '../../filters/ProductTypeFilter.jsx';
import AcquirerFilter from '../../filters/AcquirerFilter.jsx';
import TenderModeFilter from '../../filters/TenderModeFilter.jsx';
import TxnTypeFilter from '../../filters/TxnTypeFilter1.jsx';
import IndustryCategoryFilter from '../../filters/IndustryCategoryFilter.jsx';
import DateRangeFilter from '../../filters/DateRangeFilter.jsx';
import SettledUnsettledFilter from '../../filters/settled_unsettledFilter.jsx';

const override = css `
    display: block;
    margin: 0 auto;
    border-color: red;
    text-align:center;
`;
var date_config = date_range_config('1', '1', '2020-02-01','1');
var aggrSttlTable='';

// var aplloClient = ["IAPO0213","IAPO0238","I00585","IAPO0274","IAPO0303","I00937","IAPO0392","I03011","APO0454","I03274","IAPO0393","I03010","SIND0192","SIND0257","S00595","IAPO0213","IAPO0260","I00628","IAPO0170","IAPO0196","I00538","IAPO0213","IAPO0398","I03013","IAPO0223","IAPO0246","I00616","SAPO0202","SAPO0269","S01388","IAPO0466","I03283","SIND0192","SIND0257","S00649","IAPO0394","I03012","IAPO0221","IAPO0244","I00615"]

class AggregatedSettlementReport extends Component{
    constructor(props) {
        super(props);
        this.state ={
            datefrom:date_config.start_date,
            dateTo:date_config.end_date,
            datefromShow:date_config.display_start_date,
            dateToShow:date_config.display_end_date,
            yestSend:date_config.start_date_value,
            todSend:date_config.end_date_value,
            dateFromLimit: date_config.start_date_limit,
            dateLimit:date_config.end_date_limit,
            merchantList:[],
            chainList:[],
            merchantID:'',
            chainID:'',
            storeID:'',
            merchantValue:null,
            chainValue:null,
            storeList:[],
            acqBankList:[],
            acqBankValue: null,
            acqBankIds:'',
            issuerBankList:[],
            issuerBankValue:null,
            issuerBankIds:'',
            cityLists:[],
            cityValue:null,
            cityIds:'',
            loading:false,
            is_void: 1,
            model_visible : false,
            file_url: '',
            rfile: '',
            cardGradeLists:[],
            cardGradeValue:'',
            cardGradeIDs:'',
            schemeLists:[],
            schemeValue:'',
            schemeIDs:'',
            cardTypeLists:[],
            cardTypeValue:'',
            cardTypeIDs:'',
            txnissuerLists:[],
            txnissuerValue:'',
            txnissuerIDs:'',
            merchant_list_box: false,
            chain_list_box: false,
            store_list_box: false,
            acq_bank_list_box: false,
            tenderModeIDs:'',
            tenderModeValue:'',
            txnTypeLists: [],
            txnTypeIDs: ['SALE'],
            txnTypeValue: [{value: "SALE", label: "SALE"}],
            is_store_loading: true,
            isChainLoading: true,
            is_merchant_loading: true,
            ciutidList: [],
            ciutidValue: null,
            ciutidIds: '',
            is_utid_loading: true,
            slipData:'',
            isSettledLists: [],
            isSettledIDs: '',
            isSettledValue: null,
            is_fallback: 0,
            isChange: false,
            is_posbillinput: 0,
            is_prim_id:0,
            productTypeLists: [{value: '', label: 'All'}],
            productTypeIDs: 'all',
            productTypeValue: {value: '', label: 'All'},
            serviceTypeLists: [],
            serviceTypeIDs: '',
            serviceTypeValue: {value: '', label: 'All'},
            listOpen: false,
            headerTitle: "Select [Utid]",
            storeListOpen: false,
            storeHeaderTitle: "Select [Store]",
            object_code:[],
            storeObject:[],
            search_object_code:[],
            fetch_data:false,
            industryCategoryList:[],
            industryCategoryValue: null,
            industryCategoryIds:'',
            isProductLoading: true,
            state_code:''
        }
    }
    componentWillMount() {
        this.props.currentMenu("unipaynext");
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        const tokenPermission = localStorage.userPermission;
        const decoded_permission = jwt_decode(tokenPermission);
        let AllAccessPermissions = decoded_permission.accessPermissions;
        var stringCode = decoded.object_code;
        var arrayCode = stringCode.split(",");
        isReportAccess(AllAccessPermissions, 'fund_transfer_settlement');
        if(decoded.object_type==='Merchant'){
            this.setState({
                merchantID: arrayCode
            })
        }
        if(decoded.object_type==='Chain'){
            this.setState({
                chainID: arrayCode
            })
        }
        if(decoded.object_type==='Store'){
            this.setState({
                storeID: arrayCode
            })
        }

        this.setState({
            user_id:decoded._id,
            object_type: decoded.object_type,
            object_code: arrayCode,
            userType: decoded.userType,
        });
        if(decoded.userGroupName==='Meta Users')
       {
            if(decoded.object_type==='Innoviti')
            {
                var state_code = localStorage.state_code;

                if(state_code=='' || state_code=='null' || state_code==null || state_code==undefined) {
                    this.setState({
                        state_code: '',
                        productTypeIDs:'True EMI'

                    })

                } else {
                    var state_arr = state_code.split(",");
                    this.setState({
                        state_code: state_arr,
                        productTypeIDs:'True EMI'
                    })

                }
            } else {
                unauthorize_access();
            }
       }
    }
    componentDidUpdate() {
    }

    componentDidMount() {
        this.get_filtered_aggr_settle_report(this.state.object_type,this.state.object_code,'');
        user_activities(0, jwt_decode(localStorage.usertoken)._id, jwt_decode(localStorage.usertoken).firstName+' '+jwt_decode(localStorage.usertoken).lastName, jwt_decode(localStorage.usertoken).email,'aggregated_settlement_report','sparcs')
    }

    downloadAggrSettlReportCheck (e){
        let transaction_type = this.state.txnTypeIDs;
        if (Array.isArray(this.state.txnTypeIDs) && this.state.txnTypeIDs.includes("all") === true) {
            transaction_type = ""
        }
        let filters = {
            merchant_codes: this.state.merchantID,
            chain_codes: this.state.chainID,
            store_codes: this.state.storeID,
            acq_bank_codes: this.state.acqBankIds,
//             city: this.state.cityIds,
            transaction_type: transaction_type,
            settlement_status: this.state.isSettledIDs,
            product_type: this.state.productTypeIDs,
            service_type: this.state.serviceTypeIDs,
            start_date: this.state.yestSend,
            end_date: this.state.todSend,
            tender_mode: this.state.tenderModeIDs,
            utid: this.state.ciutidIds,
            category_code: this.state.industryCategoryIds,
            download: 1,
            state_code: this.state.state_code

        }
        this.setState({
            filters:filters
        })
        let is_txn = false;
        if(this.state.txnTypeIDs.length===1 && this.state.txnTypeIDs[0]==='SALE')
        {
           is_txn = true;
        }
        if(this.state.merchantID==='' && this.state.chainID==='' && this.state.storeID==='' && this.state.ciutidIds==='' && this.state.acqBankIds===''
        && this.state.isSettledIDs==='' && this.state.productTypeIDs==='all' && this.state.serviceTypeIDs==='' && is_txn ===true){
            confirmAlert({
            //title: 'Warning',
                message: "Do you really want to download all data for date range: "+this.state.datefromShow+" - "+this.state.dateToShow+" ? This will take some time to download depending on volume of data. Alternatively, please apply a filter.",
                buttons: [{
                    label: 'OK',
                    onClick: () => {
                        this.refs.downloadAllReport.downLoadReport(filters, '/report/settlement/fund-transfer','aggregated_settlement_report');
                    }
                },
                    {
                        label: 'Cancel',
                    }
                ]
            });
        } else {
            this.refs.downloadAllReport.downLoadReport(filters, '/report/settlement/fund-transfer','aggregated_settlement_report');
        }
    }

    get_filtered_aggr_settle_report(object_type, object_code, event) {

        var that = this;
        var merchants = this.state.merchantID;
        var chains = this.state.chainID;
        var stores = this.state.storeID;
        var obj_code = this.state.object_code;



        isApiResponse(false)

        if(object_type === 'Merchant' && this.state.merchantID===''){
            merchants = object_code;
        }
        if(object_type==='Chain' && this.state.chainID===''){
            chains = object_code;
        }
        if(object_type==='Store' && this.state.storeID===''){
            stores = object_code;
        }
        this.setState({
            active_mids:merchants,
            active_cids: chains,
            active_sids: stores,
            active_bids: this.state.acqBankIds,
            active_cityids: this.state.cityIds,
            active_yestSend: this.state.yestSend,
            active_todSend: this.state.todSend,
            active_is_void: this.state.is_void,
            active_card_grade: this.state.cardGradeIDs,
            active_scheme: this.state.schemeIDs,
            active_cedit_debit: this.state.cardTypeIDs,
            active_transaction_type: this.state.txnTypeIDs,
            active_utid: this.state.ciutidIds,
            active_tender_mode: this.state.tenderModeIDs,
            active_is_prim_id: this.state.is_prim_id,
            active_issuer: this.state.txnissuerIDs,
            active_is_settled: this.state.isSettledIDs,
            active_is_fallback: this.state.is_fallback,
            active_is_posbillinput: this.state.is_posbillinput
        })
        var postData = {
            mids: merchants,
            cids: chains,
            sids: stores,
            bids: this.state.acqBankIds,
            yestSend: this.state.yestSend,
            todSend: this.state.todSend,
            is_settled: this.state.isSettledIDs,
            product_type: this.state.productTypeIDs,
            service_type: this.state.serviceTypeIDs,
            utid: this.state.ciutidIds,
            transaction_type: this.state.txnTypeIDs,
            tender_mode: this.state.tenderModeIDs,
            industry_code: this.state.industryCategoryIds,
            state_code: this.state.state_code
        };
        if ($.fn.DataTable.isDataTable('#aggrSttlTable')) {
            $('#aggrSttlTable').DataTable().clear().destroy();
        }
        aggrSttlTable = $('#aggrSttlTable').DataTable(
            {
                order:[],
                //"dom": 'fltip',
                "processing": true,
                "serverSide": true,
                "bDestroy": true,
                "paging": true,
                "pageLength": 20,
                "bInfo" : false,
                "sPaginationType": "numbers",
                //"autoWidth": true,
                "responsive": false,
                "scrollX": true,
                "lengthMenu": [[20, 50, 100, 500 -1], [20, 50, 100, 500, "All"]],
                ajax: {
                    url:config.get('API_URL')+ "/summaryReport/fund-transfer-settlement",
                    type: "POST",
                    data: postData,
                    dataSrc:function ( json ) { //console.log("amondon"); console.log(json);
                        isApiResponse(true)
                        that.setState({
                            isChange: false
                        })
                        return json.data;
                    },
                    beforeSend: function(request) {
                        request.setRequestHeader("Authorization", localStorage.usertoken);
                    },
                    error: function (data) {
                         isApiResponse(true)
                         alert("Failed to load data. Please try again");
                    },
                    complete: function (data) {
                         isApiResponse(true)
                    },
                },

                columns: [
                    {"data":"Merchant",  "width": "150px",},
                    {"data":"Chain",  "width": "100px",},
                    {"data":"Store",  "width": "100px",},
                    {"data":"Store Address 1", "width": "100px"},
                    {"data":"Store Address 2", "width": "100px"},
                    {"data": "City"},
                    {"data":"State"},
                    {"data": "Product Amount"},
                    {"data": "Sale Amount"},
                    {"data": "Transaction Amount"},
                    {"data": "Instant Discount/Cashback"},
                    {"data": "No Cost EMI Amount"},
                    {"data": "Transaction Date"},
                    {"data": "Transaction Time"},
                    {"data": "Bank Merchant Id"},
                    {"data": "Btid"},
                    {"data": "Utid"},
                    {"data": "Card Number"},
                    {"data":"Bin No" },
                    {"data": "Acquiring Bank"},
                    {"data": "Issuer Bank"},
                    {"data": "Tender Mode"},
                    {"data": "Scheme"},
                    {"data": "Grade"},
                    {"data": "Credit/Debit"},
                    {"data": "RRN No"},
                    {"data": "Approval Code"},
                    {"data": "Merchant Invoice Number"},
                    {"data": "Batchsrl"},
                    {"data": "Invoice"},

                    {"data":"Processing Code"},
                    {"data": "Transaction Type"},
                    {"data": "Card Holder Name"},
                    {"data": "Is DCC Transaction"},
                    {"data": "Is International Card"},
                    {"data": "Communication Id"},
                    {"data":"Software Version"},
                    {"data": "Terminal Serial Number"},
                    {"data": "Bill Invoice Number"},
                    {"data":"Settlement Date"},
                    {"data":"Settled/Unsettled"},
                    {"data": "Acquirer RRN Number"},
                    {"data":"MDR Amount" },
                    {"data":"GST On MDR"},
                    {"data":"Bin No" },
                    {"data":"Processing Fee Amount" },
                    {"data":"GST On Proc Fee"},
                    {"data": "EMI Processing Fee"},
                    {"data": "GST On EMI Fee"},
                    {"data": "Wallet EMI Fee Amount"},
                    {"data": "GST on Wallet EMI on FEE Amount"},
                    {"data": "Wallet EMI FEE Total"},
                    {"data": "Top-Up Charges"},
                    {"data": "Customer Instant Discount"},
                    {"data": "Chargeback Amount"},
                    {"data": "EMI Discount"},
                    {"data": "BEAM CashBack"},
                    {"data": "BEAm CB Narration"},
                    {"data": "BEAM CB UTR No"},
                    {"data": "Innoviti Bearing Amount"},//56
                    {"data": "Installation Fee with GST"},
                    {"data": "Total Deduction"},
                    {"data": "Adjustment Amount"},
                    {"data": "Final Txfr Amount"},
                    {"data": "UTR Number"},
                    {"data":"service type" , "width": "200px"},
                    {"data":"Innoviti Convenience Fee"},
                    {"data":"Industry Category"},
                    {"data":"Innoviti Status"},
                    {"data":"Genie Cash Rate"},
                    {"data":"Genie Cash Fee"},
                    {"data":"GST on Genie Cash Fee"}

                ],
                "columnDefs": [
                    {
                        width: "150px",
                        targets: 0,
                    },
                    {
                        width: "130px",
                        targets: 1,
                    },

                    {
                        render: function (data, type, full, meta) {
                            if(data===null || data===''|| data ==='null'){
                            data = '';
                            }
                            return "<div class='text-wrap width-150'>" + data + "</div>";
                        },
                        "targets": [0,1,2,3,4]
                    },


                ]


            });



        if(object_type=="Innoviti" || object_type=="Admin") {
            aggrSttlTable.columns(56).visible(true);
        } else {
            aggrSttlTable.columns(56).visible(false);
        }
    }
    reset_all(e){
        this.refs.daterangeFilter.restDateFilter(date_config.start_date,date_config.end_date,date_config.display_start_date, date_config.display_end_date, date_config.start_date_value,date_config.end_date_value);
        if(this.state.object_type==='Innoviti')
        {
            this.refs.merchantFilter.restMerchantFilter();
            this.refs.reloadChain.getChain(this.state.object_code, 'innoviti', this.state.object_type, this.state.object_code);
            this.refs.reloadStore.getStore(this.state.object_code, 'innoviti', this.state.object_type, this.state.object_code, false,'');
            this.refs.reloadUtid.ci_utid('','','',false,'');
        }
        if(this.state.object_type==='Merchant')
        {
            this.refs.reloadChain.getChain(this.state.object_code, 'merchant', this.state.object_type, this.state.object_code);
            this.refs.reloadStore.getStore(this.state.object_code, 'merchant', this.state.object_type, this.state.object_code,false,'');
            this.refs.reloadUtid.ci_utid(this.state.object_code,'','',false,'');
        }
        if(this.state.object_type==='Chain')
        {
            this.refs.reloadStore.getStore(this.state.object_code, 'chain', this.state.object_type, this.state.object_code,false,'');
            this.refs.reloadUtid.ci_utid('',this.state.object_code,'',false,'');
        }
        if(this.state.object_type==='Store')
        {
            this.refs.reloadUtid.ci_utid('','',this.state.object_code,false,'');
        }
        if(this.state.object_type=='Innoviti' || this.state.object_code.includes("RELI0001")===true)
        {
            this.refs.serviceFilter.restServiceFilter();
            this.refs.productTypeFilter.resetProductTypeFilter();

        }

        this.refs.tenderModeFilter.restTenderModeFilter();
        this.refs.txnTypeFilter.resetTxnTypeFilter();
        this.refs.settledFilter.resetSettledFilter();
        this.refs.acquirerFilter.resetAcquirerFilter();
        this.refs.industryCategoryFilter.resetIndustryCategoryFilter();
        this.setState({
            datefrom:date_config.start_date,
            dateTo:date_config.end_date,
            datefromShow:date_config.display_start_date,
            dateToShow:date_config.display_end_date,
            yestSend:date_config.start_date_value,
            todSend:date_config.end_date_value,
            merchantID:'',
            chainID:'',
            storeID:'',
            storeValue:[],
            merchantValue:[],
            chainValue:[],
            acqBankValue: [],
            acqBankIds:'',
            issuerBankValue:[],
            issuerBankIds:'',
            cityValue:[],
            cityIds:'',
            is_void:1,
            file_url: '',
            rfile: '',
            cardGradeValue:[],
            cardGradeIDs:'',
            schemeValue:[],
            schemeIDs:'',
            cardTypeValue:[],
            cardTypeIDs:'',
            txnissuerValue:[],
            txnissuerIDs:'',
            emiIssuerValue:[],
            emiIssuerIDs:'',
            txnTypeIDs: ['SALE'],
            txnTypeValue: [{value: "SALE", label: "SALE"}],
            ciutidValue: [],
            ciutidIds: '',
            isSettledIDs: '',
            isSettledValue: [],
            isChange: false,
            is_posbillinput: 0,
            is_prim_id:0,
            tenderModeIDs:'',
            tenderModeValue:[],
            is_fallback: 0,
            serviceTypeIDs: '',
            serviceTypeValue: {value: '', label: 'All'},
            productTypeIDs: '',
            productTypeValue: {value: '', label: 'All'},
            industryCategoryIds:'',

        })

        setTimeout(function(){
            this.componentWillMount()
            this.componentDidMount()
        }.bind(this), 200);
    }
    handleDateRange = (todSend, yestSend, datefromShow,dateToShow) =>
    {
        this.setState({
            todSend: todSend,
            yestSend: yestSend,
            datefromShow: datefromShow,
            dateToShow: dateToShow,
            isChange: true,
        });

    }
    handleMerchant = (optionSelected, merchantID) =>
    {
        this.setState({
            merchantID:merchantID,
            isChange: true,
            chainID:'',
            storeID:'',
            ciutidIds: '',
        });
        this.refs.reloadChain.getChain(merchantID, 'merchant', this.state.object_type, this.state.object_code);
        this.refs.reloadStore.getStore(merchantID, 'merchant', this.state.object_type, this.state.object_code,false,'');
        this.refs.reloadUtid.ci_utid(merchantID, '','',false,'');
    }
    handleChain = (optionSelected, chainID) =>
    {
        this.setState({
            chainID:chainID,
            isChange: true,
            storeID:'',
            ciutidIds: '',
        });
        this.refs.reloadStore.getStore(chainID, 'chain', this.state.object_type, this.state.merchantID,false,'');
        this.refs.reloadUtid.ci_utid(this.state.merchantID, chainID,'',false,'');
    }

    handleStore = (storeID) =>
    {
        this.setState({
            storeID:storeID,
            isChange: true,
            ciutidIds: '',

        });
        this.refs.reloadUtid.ci_utid(this.state.merchantID, this.state.chainID,storeID,false,'');
    }
    handleUtid = (utid) =>
    {
        this.setState({
            ciutidIds:utid,
            isChange: true
        });

    }

    handleService = (serviceData) =>{
        const value = serviceData === null ? '' : serviceData.value;
        this.setState({
            isChange: true,
            serviceTypeIDs:value,
        })
    }
    handleTenderMode = (optionSelected, tenderModeIDs) =>
    {
        this.setState({
            tenderModeIDs:tenderModeIDs,
            isChange: true
        });
    }
    handleTxnType = (optionSelected, txnTypeIDs) =>
    {
        this.setState({
            txnTypeIDs:txnTypeIDs,
            isChange: true
        });
    }
    handleSettled = (optionSelected, isSettledIDs) =>
    {
        this.setState({
            isSettledIDs:isSettledIDs,
            isChange: true
        });
    }
    handleAcquirer = (optionSelected, acqBankIds) =>
    {
        this.setState({
            acqBankIds:acqBankIds,
            isChange: true
        });
    }
    handleProduct = (productData) =>{
        const value = productData === null ? '' : productData.value;
        this.setState({
            isChange: true,
            productTypeIDs:value,
        })
    }
    handleIndustryCategoryFilter = (optionSelected, industryCategoryIds) =>
    {
        this.setState({
            industryCategoryIds:industryCategoryIds,
            isChange: true
        });
    }
    handleFallBack = (is_fallback) => {
        this.setState({is_fallback: is_fallback, isChange: true});
    }
    handlePosBill = (is_posbillinput) => {
        this.setState({is_posbillinput: is_posbillinput, isChange: true});
    }
    handlePrimId = (is_prim_id) => {
        this.setState({is_prim_id: is_prim_id, isChange: true});
    }

    render() {
        return(

            <div className="content-invoice">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card">
                                <div className="col-md-9 no-padd">
                                    <div className="header">
                                        <h4 className="title">Aggregated Settlement Report</h4>
                                        <p className="category"></p>
                                    </div>
                                </div>
                                <div className="col-md-3 pull-right">
                                    <div className="r-p-menu">
                                        {/*<SalesMenu></SalesMenu>*/}
                                    </div>
                                </div>
                                <div className = "clearfix"></div>
                                <div className = "content">
                                    <div className="row">
                                        <div className="col-md-12 filter-border-right">
                                            <div className="col-md-2 filter-bottom5 padd-5 date-icon-small">
                                                <div><label> Date Filter: </label></div>
                                                 <DateRangeFilter ref="daterangeFilter" onSelectDate = {this.handleDateRange} start_date = {this.state.datefrom} end_date={this.state.dateTo} display_start_date = {this.state.datefromShow} display_end_date = {this.state.dateToShow}
                                                start_date_limit = {this.state.dateFromLimit} end_date_limit = {this.state.dateLimit}/>
                                            </div>
                                            {this.state.object_type ==='Innoviti'?
                                                <div className="col-md-2 filter-bottom5 padd-5">
                                                    <label>Merchants</label>
                                                    <MerchantFilter ref="merchantFilter" onSelectMerchant = {this.handleMerchant} object_type = {this.state.object_type} object_code={this.state.object_code} user_type = {this.state.userType}/>
                                                    <div className="clearfix"></div>
                                                </div> : null}
                                            {this.state.object_type ==='Innoviti' || this.state.object_type ==='Merchant'?
                                                <div className="col-md-2 filter-bottom5 padd-5">
                                                    <label> Chain </label>
                                                    <ChainFilter ref= "reloadChain" onSelectChain = {this.handleChain} object_type = {this.state.object_type} object_code={this.state.object_code} user_type = {this.state.userType}/>
                                                    <div className="clearfix"></div>
                                                </div>: null }
                                            {this.state.object_type ==='Innoviti' || this.state.object_type ==='Merchant' || this.state.object_type ==='Chain'?
                                                <div className="col-md-2 filter-bottom5 padd-5" >
                                                    <label> Store: </label>
                                                    <StoreFilter ref= "reloadStore" onSelectStore = {this.handleStore} object_type = {this.state.object_type} object_code={this.state.object_code} user_type = {this.state.userType}/>
                                                    <div className="clearfix"></div>
                                                </div>: null }
                                            <div className="col-md-2 filter-bottom5 padd-5" >
                                                <label> Utid: </label>
                                                <UtidFilter ref = "reloadUtid" onSelectUtid = {this.handleUtid} object_type = {this.state.object_type} object_code={this.state.object_code} user_type = {this.state.userType}/>
                                                <div className="clearfix"></div>
                                            </div>
                                            {/*{this.state.acq_bank_list_box===true?*/}
                                            <div className="col-md-2 filter-bottom5 padd-5">
                                                <label>Acquirer:</label>
                                                <AcquirerFilter ref="acquirerFilter" onSelectAcquirer = {this.handleAcquirer}/>
                                                <div className="clearfix"></div>
                                            </div>


                                            <div className="col-md-2 filter-bottom5 padd-5">
                                                <label> Settled/Unsettled </label>
                                                <SettledUnsettledFilter ref="settledFilter" onSelectSettled = {this.handleSettled}/>
                                                <div className="clearfix"></div>
                                            </div>
                                            {this.state.object_type=='Innoviti' || this.state.object_code.includes("RELI0001")===true?
                                                <div className="col-md-2 filter-bottom5 padd-5">
                                                <label> Product Type </label>
                                                 <ProductTypeFilter ref="productTypeFilter" onSelectProduct = {this.handleProduct} userType={this.state.userType}/>
                                                 <div className="clearfix"></div>
                                                </div>: null }

                                            {this.state.object_type=='Innoviti' || this.state.object_code.includes("RELI0001")===true?
                                                <div className="col-md-2 filter-bottom5 padd-5">
                                                    <label> Service Type </label>
                                                    <ServiceFilter ref="serviceFilter" onSelectService = {this.handleService} userType={this.state.userType}/>
                                                    <div className="clearfix"></div>
                                                </div>: null }
                                            <div className="col-md-2 filter-bottom5 padd-5">
                                                <label> Txn Type </label>
                                                <TxnTypeFilter ref="txnTypeFilter" onSelectTxnType = {this.handleTxnType} is_upi_leg1 = 'No' />
                                                <div className="clearfix"></div>
{/*                                                 <div className="clearfix"></div> */}
{/*                                                 <div className="clearfix"></div> */}
                                            </div>

                                            <div className="col-md-2 filter-bottom5 padd-5">
                                                <label> Tender Mode </label>
                                                <TenderModeFilter ref="tenderModeFilter" onSelectTenderMode = {this.handleTenderMode} />
                                                <div className="clearfix"></div>
                                            </div>
                                            <div className="col-md-2 filter-bottom5 padd-5">
                                                <label> Industry Category: </label>
                                               <IndustryCategoryFilter ref="industryCategoryFilter" onSelectIndustryCategoryFilter = {this.handleIndustryCategoryFilter}/>
                                                <div className="clearfix"></div>
                                            </div>

                                        </div>

                                    </div>
                                    <div className="row">
                                        <div className="col-md-5 pull-right">
                                            {this.state.isChange===true?
                                                <span className="apply-notification">Please click on Apply button</span>:null
                                            }
                                            <button type="button" className="primary apply-filter" role="button" disabled={!this.state.isChange} onClick={this.get_filtered_aggr_settle_report.bind(this, this.state.object_type,this.state.object_code)}>Apply</button>
                                            <button type="button" className="primary reset-filter" role="button"  onClick={this.reset_all.bind(this)}>Reset</button>
                                        </div>
                                    </div>


                                    <div className="clearfix"></div>
                                    <div className="row">
                                        <div className="ro-sep"></div>
                                    </div>
                                    <div className="">
                                        <a href="#" className="exportButton" role="button" onClick={this.downloadAggrSettlReportCheck.bind(this)}>
                                            <i className="fa fa-download" aria-hidden="true"></i>
                                            Export to CSV
                                        </a>
                                    </div>
                                    <div className="clearfix"></div>
                                    <div className="content-tdetails-table table-full-width marginTop0">
                                        <table id="aggrSttlTable" className="table table-striped table-hover">
                                            <thead>
                                            <tr>
                                                <th>Merchant</th>
                                                <th>Chain</th>
                                                <th>Store</th>
                                                <th>Store Address 1</th>
                                                <th>Store Address 2</th>
                                                <th>City</th>
                                                <th>State</th>
                                                <th>Product Amount</th>
                                                <th>Sale Amount</th>
                                                <th>Transaction Amount</th>
                                                <th>Instant Discount/Cashback</th>
                                                <th>No Cost EMI Amount</th>
                                                <th>Transaction Date</th>
                                                <th>Transaction Time</th>
                                                <th>Bank Merchant Id</th>
                                                <th>Btid</th>
                                                <th>Utid</th>
                                                <th>Card Number</th>
                                                <th>Bin No</th>
                                                <th>Acquiring Bank</th>
                                                <th>Issuer Bank</th>
                                                <th>Tender Mode</th>
                                                <th>Scheme</th>
                                                <th>Grade</th>
                                                <th>Credit/Debit</th>
                                                <th>RRN No</th>
                                                <th>Approval Code</th>
                                                <th>Merchant Invoice Number</th>
                                                <th>Batchsrl</th>
                                                <th>Invoice</th>

                                                <th>Processing Code</th>
                                                <th>Transaction Type</th>
                                                <th>Card Holder Name</th>
                                                <th>Is DCC Transaction</th>
                                                <th>Is International Card</th>
                                                <th>Communication Id</th>
                                                <th>Software Version</th>
                                                <th>Terminal Serial Number</th>
                                                <th>Bill Invoice Number</th>
                                                <th>Settlement Date</th>
                                                <th>Settled/Unsettled</th>
                                                <th>Acquirer RRN Number</th>
                                                <th>MDR Amount</th>
                                                <th>GST On MDR</th>
                                                <th>Bin No</th>
                                                <th>Processing Fee Amount</th>
                                                <th>GST On Proc Fee</th>
                                                <th>EMI Processing Fee</th>
                                                <th>GST On EMI Fee</th>
                                                <th>Wallet EMI Fee Amount</th>
                                                <th>GST on Wallet EMI on FEE Amount</th>
                                                <th>Wallet EMI FEE Total</th>
                                                <th>Top-Up Charges</th>
                                                <th>Customer Instant Discount</th>
                                                <th>Chargeback Amount</th>
                                                <th>EMI Discount</th>
                                                <th>BEAM CashBack</th>
                                                <th>BEAM CB Narration</th>
                                                <th>BEAM CB UTR No</th>
                                                <th>Innoviti Bearing Amount</th>
                                                <th>Installation Fee with GST</th>
                                                <th>Total Deduction</th>
                                                <th>Adjustment Amount</th>
                                                <th>Final Txfr Amount</th>
                                                <th>UTR Number</th>
                                                <th>Service Type</th>
                                                <th>Innoviti Convenience Fee</th>
                                                <th>Industry Category</th>
                                                <th>Innoviti Status</th>
                                                <th>Genie Cash Rate</th>
                                                <th>Genie Cash Fee</th>
                                                <th>GST on Genie Cash Fee</th>

                                            </tr>
                                            </thead>
                                            <tbody>

                                            </tbody>
                                        </table>
                                    </div>
                                    <DownloadAllReport ref="downloadAllReport" />

                                    <div className="footer">
                                        <div className="stats"><i></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        );
    }
}

const mapDispatchToProps = (dispatch) =>{
    return {
        currentMenu: (name)=>{dispatch({type:'change_menu',payload:name})}
    }
}
export default connect(null,mapDispatchToProps)(AggregatedSettlementReport)